import { openModal } from '@core/components/ModalStack';
import { ActionSettingsModalProps } from './ActionSettingsModal';

export async function openActionSettingsModal(props: ActionSettingsModalProps) {
  const { ActionSettingsModal } = await import('./ActionSettingsModal');

  openModal(ActionSettingsModal, props);
}
